import React from 'react';
import PropTypes from 'prop-types';
import PhoneInput from 'react-phone-input-2';
import TextBox from '../TextBox';
import Address from '../PersonalInfo/Address/Address';

const TrustedContact = (props) => {
  const {
    countries,
    regions,
    handleOnChangeCountry,
    countryOfResidence,
  } = props;

  return (
    <div className="row">
      <div className="contact">
        <h1 className="h2_subHeading">
          Trusted Contact Information:
        </h1>
        <TextBox
          name="fullName"
          className="form-control"
          label="Full Name"
          maxLength={60}
        />
        <TextBox
          name="relationship"
          className="form-control"
          label="Relationship"
          maxLength={60}
        />
        <TextBox
          type="email"
          name="email"
          className="form-control"
          label="Email Address"
          maxLength={50}
        />
        <div>
          <PhoneInput
            id="phone"
            name="phone"
            label="Phone Number"
            maxLength={25}
            inputClass={props.phoneStatus === 'false' ? 'phoneInput phoneError' : 'phoneInput'}
            countryCodeEditable={false}
            enableSearch
            enableTerritories
            disableDropdown
            placeholder="Phone Number"
            priority={{ gb: 0, je: 1 }}
            country={props.phoneCountry}
            value={props.phone}
            onChange={phone => props.handlePhoneChange(phone)}
          />
          <div className="form-group label-floating has-error">
            <div className="messages">
              {props.phoneStatus === 'false' &&
                <p className="help-block error phoneErrorMessage">Not a valid Phone Number</p>}
            </div>
          </div>
        </div>
        <br />
      </div>
      <h1 className="h2_subHeading adress-sub">
        Address:
      </h1>
      <Address
        countries={countries}
        regions={regions}
        handleOnChangeCountry={handleOnChangeCountry}
        country={countryOfResidence}
        autoCompleteSection="section-trusted-contact"
      />
    </div>
  );
};

TrustedContact.propTypes = {
  countries: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })),
  regions: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  }))).isRequired,
  handleOnChangeCountry: PropTypes.func.isRequired,
  countryOfResidence: PropTypes.string,
  handlePhoneChange: PropTypes.func,
  phoneCountry: PropTypes.string,
  phoneStatus: PropTypes.string,
  phone: PropTypes.string,
};

export default TrustedContact;

